import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuthStore } from '../stores/auth.store';

export const Route = createFileRoute('/')({
  component: IndexPage,
});

function IndexPage() {
  const user = useAuthStore((state) => state.user);

  if (user) {
    return <Navigate to="/workspaces" />;
  }

  return <Navigate to="/login" />;
}

